export default __webpack_public_path__ + "static/media/bg-faq.8fd6a11a.png";